module.exports = __webpack_public_path__ + "img/satellite4.efa8ed89.png";